import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Inbox18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.36006 2.25H14.6613C15.1817 2.25085 15.6737 2.59936 15.8472 3.09L15.8526 3.10602L17.6114 8.46229C17.7054 8.73946 17.7522 9.03042 17.7501 9.32308V14.5C17.7501 15.1808 17.1809 15.75 16.5001 15.75H1.50006C0.819225 15.75 0.250059 15.1808 0.250059 14.5V9.33265C0.248113 9.03483 0.294556 8.73868 0.387581 8.45575L0.388947 8.45163L2.17585 3.12088C2.33317 2.61632 2.83103 2.24982 3.36006 2.25ZM14.4853 3.75H3.54699L2.03856 8.25001H5.49155C5.97572 8.22016 6.45793 8.49999 6.6718 8.9365L7.33755 10.25H10.6961L11.4033 8.92629C11.6102 8.51577 12.0551 8.24502 12.515 8.25001H15.9629L14.4853 3.75ZM16.2501 9.75001H12.6639L11.9533 11.0801C11.7432 11.4812 11.3089 11.7464 10.856 11.75L10.85 11.75L7.17405 11.75C6.71923 11.7464 6.28326 11.4789 6.07405 11.075L6.071 11.0691L5.40245 9.75001H1.75006V14.25H16.2501L16.2501 9.75001Z'
      fill='currentColor'
    />
  </Svg>
);

Inbox18.displayName = 'Inbox18';
export default Inbox18;
